import { Button } from 'evergreen-ui'
import React from 'react'
import { Link } from 'react-router-dom'
import { useBreakpoint } from '/fiweb/lib'
import CardSection from './CardSection'
import { useFinishedCampaignCardsQuery } from '/~/types/graphql'
import { normalizeNewApiCampaignCards, normalizeOldApiCampaignCards } from '/~/utils/campaignCard'
import { sortCampaignCards } from '/~/utils/arraySorting'
import { CardTypeEnum } from '/fiweb/components/CampaignCard/types'
import { client } from '/~/lib/issuer-client/client'
import { PublishedCampaignCardState, useGetPublishedCampaignCardsByStateQuery } from '/~/types/issuer-graphql'

const Finished = () => {
  const { data, loading } = useFinishedCampaignCardsQuery({
    notifyOnNetworkStatusChange: true,
  })

  const { data: newApiData, loading: newApiLoading } = useGetPublishedCampaignCardsByStateQuery({
    variables: { state: [PublishedCampaignCardState.FINISHED] },
    skip: !client,
    notifyOnNetworkStatusChange: true,
    client,
  })

  const cardList = React.useMemo(
    () => [
      ...normalizeOldApiCampaignCards(data?.finishedCampaignCards?.list || []),
      ...normalizeNewApiCampaignCards(newApiData?.publishedCampaignCardsByState || []),
    ],
    [data, newApiData],
  )

  const cards = React.useMemo(() => sortCampaignCards(cardList || [], CardTypeEnum.FINISHED).slice(0, 6), [cardList])

  const { medium } = useBreakpoint()

  const button = (
    <Button
      marginLeft={medium ? 10 : 0}
      marginBottom={medium ? 25 : 0}
      size='small'
      backgroundColor='initial'
      is={Link}
      to='avsluttede'
    >
      {medium ? 'Se alle' : 'Se alle avsluttede emisjoner'}
    </Button>
  )

  return (
    <CardSection
      name='finished'
      id='avsluttede-emisjoner'
      title='Avsluttede emisjoner'
      description='Her kan du se emisjoner som allerede er gjennomført.'
      ctaButton={button}
      loading={loading || newApiLoading}
      cards={cards}
      ignoreAdCard
    />
  )
}

export default Finished
